var _path, _mask, _g, _path2, _path3, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M12.87 40.774c-.89 0-1.612.722-1.612 1.613v6c0 .891.722 1.613 1.613 1.613.89 0 1.613-.722 1.613-1.613v-6c0-.89-.723-1.613-1.613-1.613",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "fyhmwnebla",
    width: 4,
    height: 17,
    x: 34,
    y: 33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M34.645 33.912h3.226V50h-3.226V33.912z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fyhmwnebla)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M36.258 33.912c-.89 0-1.613.723-1.613 1.613v12.862c0 .891.723 1.613 1.613 1.613s1.613-.722 1.613-1.613V35.525c0-.89-.722-1.613-1.613-1.613",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M12.87 16.13c.891 0 1.614-.723 1.614-1.614V1.613C14.484.723 13.76 0 12.87 0s-1.613.723-1.613 1.613v12.903c0 .89.722 1.613 1.613 1.613",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M20.13 12.903c-.891 0-1.614.723-1.614 1.613 0 3.112-2.533 5.645-5.645 5.645-3.113 0-5.645-2.533-5.645-5.645V1.613C7.226.723 6.503 0 5.613 0S4 .723 4 1.613v12.903c0 4.34 3.135 7.955 7.258 8.717v12.592c0 .89.723 1.613 1.613 1.613s1.613-.722 1.613-1.613V23.233c4.123-.762 7.258-4.377 7.258-8.717 0-.89-.723-1.613-1.613-1.613M20.13 0c-.89 0-1.613.723-1.613 1.613v5.3c0 .89.722 1.612 1.613 1.612.89 0 1.612-.722 1.612-1.613v-5.3C21.742.723 21.02 0 20.13 0",
    clipRule: "evenodd"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "24bex3vjib",
    width: 19,
    height: 29,
    x: 27,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.388 0H45.13v28.8H27.388V0z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#24bex3vjib)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M36.259 20.161c-3.113 0-5.645-2.615-5.645-5.83 0-4.794 3.55-11.105 5.645-11.105 2.436 0 5.645 6.985 5.645 11.105 0 3.215-2.533 5.83-5.645 5.83m8.87-5.83c0-2.37-.921-5.833-2.291-8.614C40.994 1.977 38.72 0 36.258 0c-2.46 0-4.736 1.977-6.578 5.717-1.371 2.781-2.292 6.244-2.292 8.614 0 4.43 3.134 8.12 7.258 8.899v3.957c0 .89.722 1.613 1.613 1.613.89 0 1.613-.722 1.613-1.613V23.23c4.122-.778 7.258-4.469 7.258-8.9",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.019654e31a9a523821cf5cd3494054fc.svg";
export { ForwardRef as ReactComponent };